var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('address-link',{attrs:{"address":_vm.address}}),_c('amount-tag',{attrs:{"amount":"010239882028020303828201","symbol":_vm.currentChain.symbol}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }